import { render } from "./profiletab.vue?vue&type=template&id=65972ba8"
import script from "./profiletab.vue?vue&type=script&lang=js"
export * from "./profiletab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__